import { useAuth } from '../AuthenticatedApp';

export const useVenueId = () => {
  const { venueId } = useAuth();
  return venueId;
};

export const useUserPermissions = () => {
  const { userPermissions } = useAuth();
  return Array.isArray(userPermissions) ? userPermissions : [];
};
